import { Component } from '@angular/core';

import { Storage } from '@ionic/storage';

import { TranslateService } from '@ngx-translate/core';

import { BehaviorSubject } from "rxjs/Rx";

import { Events, IonicPage, ModalController, NavController, NavParams, ViewController } from 'ionic-angular';

import { OrderPage } from '../order/order';
import { PosmSubitemDescriptionPage } from '../posm-subitem-description/posm-subitem-description';
import { fadeInOutAnimation } from '../../animations/fade-in-out';
import { listAnimation } from '../../animations/list-animation';
import { PosmSubitem } from '../../models/posm-subitem.model';
import { AuthProvider } from '../../providers/auth/auth';
import { OrderProvider } from "../../providers/order/order";
@IonicPage()
@Component({
  selector: 'page-basket',
  templateUrl: 'basket.html',
  animations: [
    fadeInOutAnimation,
    listAnimation
  ]
})
export class BasketPage {

  protected basket: Array<PosmSubitem> = new Array();
  private authorized: boolean = true;
  private userRoleName: string;
  private userShopId: number;
  public currentPage: String;
  public subscriberEnter;

  public inBasket: BehaviorSubject<boolean> = new BehaviorSubject(false);

  posmSubitemDescription: PosmSubitemDescriptionPage;

  constructor(protected storage: Storage, public events: Events, public orderProvider: OrderProvider, public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, public translate: TranslateService, public modalCtrl: ModalController, public authProvider: AuthProvider) {
    this.posmSubitemDescription = new PosmSubitemDescriptionPage(storage, navCtrl, navParams, translate, modalCtrl);

    if (this.viewCtrl.name !== 'ModalCmp') {

      let eventCallBack:any = (caller) => {
        if (!caller || this.viewCtrl.name !== caller) {
          this.reloadBasketContent();
        }
      }

      events.subscribe('basket:refresh', eventCallBack);

      this.subscriberEnter = this.navCtrl.viewDidEnter.subscribe((view) => {
        if (!this.currentPage) {
          this.currentPage = view.instance.constructor.name;
        }

        if ((this.currentPage == 'PosmSubitemsPage'
        && (view.instance.constructor.name == 'PosmCategoriesPage' || view.instance.constructor.name == 'PosmItemsPage'))
        ||
        (this.currentPage == 'PosmItemsPage'
        && view.instance.constructor.name == 'PosmCategoriesPage')) {
          events.unsubscribe('basket:refresh', eventCallBack);
          this.subscriberEnter.unsubscribe();
        }
      });
    }
  }

  closeModal() {
    this.navCtrl.pop();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  public get basketLength () {
    return (this.basket? this.basket.length : 0);
  }

  public increaseBasketElementInBasket (BasketElement: PosmSubitem) {
    var res: any = false;
    let BasketElementIndex;

    BasketElement.asked_quantity += 1;
    BasketElement.quantity -= 1;

    if (this.basketLength) {
      BasketElementIndex = this.getBasketPosmSubitemId(BasketElement);

      if (BasketElementIndex === undefined) {
        this.basket.push(BasketElement);
        if (this.basketLength > 0)
          res = this.basket.slice(-1)[0];
      } else {
        const basketPosmSubitem = this.basket[BasketElementIndex];
        if (!BasketElement.is_notMultiorder && (basketPosmSubitem.asked_quantity < 4) && (basketPosmSubitem.asked_quantity > 0)) {
          res = this.basket[BasketElementIndex];
        }
      }
    } else {
      this.basket.push(BasketElement);
      if (this.basketLength > 0)
        res = this.basket.slice(-1)[0];
    }

    this.storage.set('basket', this.basket).then(() => {
      this.events.publish('basket:refresh', this.viewCtrl.name);
    });

    return res;
  }

  public decreaseBasketElementInBasket (BasketElement: PosmSubitem) {
    const BasketElementIndex = this.getBasketPosmSubitemId(BasketElement);
    let res: any = false;
    if (BasketElementIndex !== undefined) {
      this.basket[BasketElementIndex].asked_quantity -= 1;
      this.basket[BasketElementIndex].quantity += 1;
      if (this.basket[BasketElementIndex].asked_quantity > 0) {
        this.storage.set('basket', this.basket).then(() => {
          this.events.publish('basket:refresh', this.viewCtrl.name);
        });
        res = this.basket[BasketElementIndex];
      } else {
        res = this.removeBasketElement(BasketElementIndex);
      }
    }

    return res;
  }

  public removeBasketElement (BasketElement: PosmSubitem | number) {
    let BasketElementIndex: any;

    if(typeof BasketElement === 'object') {
      BasketElementIndex = this.getBasketPosmSubitemId(BasketElement);
    } else {
      BasketElementIndex = BasketElement;
    }

    if (BasketElementIndex !== undefined) {
      this.basket.splice(BasketElementIndex, BasketElementIndex+1);
      this.storage.set('basket', this.basket).then(() => {
        this.events.publish('basket:refresh', this.viewCtrl.name);
      });
    }

    if( this.inBasket.getValue() && this.basketLength == 0)
      this.navCtrl.pop();

    return this.basket;
  }

  public clearBasket () {
    this.basket = new Array();
    this.storage.set('basket', this.basket).then(() => {
      this.events.publish('basket:refresh', this.viewCtrl.name);
    });
  }

  public async reloadBasketContent () {
    this.basket = await this.storage.get('basket');
  }

  private getBasketPosmSubitemId (BasketElement: PosmSubitem) {
    var BasketElementIndex = undefined;
    for (const key of Object.keys(this.basket)) {
      if (this.basket[key].id === BasketElement.id) {
        BasketElementIndex = key;
        break;
      }
    }

    return BasketElementIndex;
  }

  public showBasket() {
    this.inBasket.next(true);
    this.storage.get('current_brand').then((brand) => {
      let basketModal = this.modalCtrl.create(BasketPage, {}, {cssClass: brand.name});
      basketModal.present();
      basketModal.onDidDismiss(() => {
        this.inBasket.next(false);
      });
    });
  }

  basketValidate() {
    if((this.userRoleName === 'superadmin'
    || this.userRoleName === 'admin'
    || this.userRoleName === 'sales-force-plus'
    || this.userRoleName === 'sales-force'
    || this.userRoleName === 'shop-salesman'
    || this.userRoleName === 'shop-manager') && this.userShopId) {

      this.storage.get('current_brand').then((brand) => {
        this.reloadBasketContent();
        let tosModal = this.modalCtrl.create(OrderPage, {
          orderType: "delivery",
          basket : this.basket
        }, { cssClass: brand.name });
        tosModal.present();
        tosModal.onDidDismiss(() => {
          this.clearBasket();
          this.inBasket.next(false);
        });
      });
    } else {
      this.authorized = false;
    }
  }

  private getProfile() {
    this.authProvider.profile()
    .subscribe(
      user => {
        this.userRoleName = user.role_name;
        this.userShopId = user.shop_id;
      }
    );
  }

  ionViewDidLoad() {
    this.inBasket.next(true);
    this.reloadBasketContent();
    this.getProfile();
  }
}



// WEBPACK FOOTER //
// ./src/pages/basket/basket.ts